import { GetTasksResponse } from "@/modules/tasks/api/queries/getTasksQuery";
import { subtaskResourceType } from "@/modules/tasks/api/resources/subtask/subtaskResourceConsts";
import { SubtaskResource } from "@/modules/tasks/api/resources/subtask/subtaskResourceStruct";

import { ParsedDashboardTasksItem } from "../../types/types";

import { parseSubtasks } from "./parseSubtasks";

export function parseDashboardTasksList(
  response: GetTasksResponse
): ParsedDashboardTasksItem[] {
  const { data, included } = response;

  const parsedDashboardTasksList = data.map((taskItem) => {
    const itemSubtasksIds = taskItem.relationships.subtasks.data.map(
      (subtask) => subtask.id
    );

    const itemSubtasks = included
      .filter(
        (item): item is SubtaskResource => item.type === subtaskResourceType
      )
      .filter((subtask) => itemSubtasksIds.includes(subtask.id));

    const parsedSubtasks = parseSubtasks(itemSubtasks);

    return {
      id: taskItem.id,
      name: taskItem.attributes.name,
      deadline: taskItem.attributes.deadline,
      date: taskItem.attributes.date,
      pointsNumber: taskItem.attributes.pointsNumber,
      progress:
        (parsedSubtasks.filter((subtask) => subtask.completedBy).length /
          parsedSubtasks.length) *
        100,
      subtasks: parsedSubtasks,
      rated:
        parsedSubtasks.filter((subtask) => subtask.rating).length ===
        parsedSubtasks.length,
    };
  });
  return parsedDashboardTasksList;
}
